import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Tooltip } from "bootstrap";
import {
  NON_QUALIFIED_RESULT_HINT_MESSAGE,
  QUALIFIED_RESULT_HINT_MESSAGE,
} from "../Constants";

export const SpectraRowHeader: React.FC = () => {
  const resultToolTipRef = useRef(null);
  const nonQualifiedResultRef = useRef(null);

  useEffect(() => {
    if (!resultToolTipRef.current) return;
    if (!nonQualifiedResultRef.current) return;

    new Tooltip(resultToolTipRef.current, {
      title: QUALIFIED_RESULT_HINT_MESSAGE,
      placement: "top",
      trigger: "hover",
    });

    new Tooltip(nonQualifiedResultRef.current, {
      title: NON_QUALIFIED_RESULT_HINT_MESSAGE,
      placement: "top",
      trigger: "hover",
    });
  });

  return (
    <div className="d-none d-lg-block overview-results__header bg-primary py-20 px-30">
      <div className="row">
        <div className="col-2">
          <strong className="text-black">Filename</strong>
        </div>
        <div className="col-2">
          <strong className="text-black">Sample Name</strong>
        </div>
        <div className="col-1">
          <strong className="text-black">Datacount</strong>
        </div>
        <div className="col-1">
          <strong className="text-black">Score</strong>
        </div>
        <div className="col-3">
          <strong className="text-black">
            Qualified result{" "}
            <FontAwesomeIcon
              icon={faInfoCircle as IconProp}
              ref={resultToolTipRef}
            />
          </strong>
        </div>
        <div className="col-1">
          <strong className="text-black">Score</strong>
        </div>
        <div className="col-2 pr-0">
          <strong className="text-black">
            Non-Qualified result{" "}
            <FontAwesomeIcon
              icon={faInfoCircle as IconProp}
              ref={nonQualifiedResultRef}
            />
          </strong>
        </div>
      </div>
    </div>
  );
};
